import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiBell } from "react-icons/fi";
import useInboxUnreadCount from "../../hooks/useInboxUnreadCount";

const NotificationBell = ({
  role = "user",
  to,
  enabled = true,
  unreadCount: unreadCountProp,
  className = "",
  iconSize = 20,
}) => {
  const { t } = useTranslation();
  const { unreadCount: fetchedCount } = useInboxUnreadCount(role, enabled && unreadCountProp == null);
  const unreadCount = unreadCountProp != null ? unreadCountProp : fetchedCount;
  const href = to || (role === "owner" ? "/restaurant/notifications" : "/notifications");

  if (!enabled) return null;

  const label = unreadCount
    ? t("notificationInbox.bellLabelUnread", { count: unreadCount > 99 ? "99+" : unreadCount })
    : t("notificationInbox.bellLabel");

  return (
    <NavLink
      to={href}
      aria-label={label}
      title={label}
      className={({ isActive }) =>
        `relative inline-flex shrink-0 items-center justify-center rounded-lg p-2 transition-colors ${
          isActive ? "bg-brand/15 text-brand" : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
        } ${className}`
      }
    >
      <FiBell size={iconSize} strokeWidth={2} />
      {unreadCount > 0 ? (
        <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] px-0.5 flex items-center justify-center rounded-full bg-brand text-white text-[9px] font-bold leading-none">
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      ) : null}
    </NavLink>
  );
};

export default NotificationBell;
